'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var fadeInDownBig = {
  from: {
    opacity: 0,
    transform: (0, _utils.translate3d)(0, '-2000px', 0)
  },
  to: {
    opacity: 1,
    transform: 'none'
  }
};
exports.default = fadeInDownBig;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/fade-in-down-big.js
// module id = 209
// module chunks = 54990529738226 257444579329143